import { render } from "./ProfileThumbnail.vue?vue&type=template&id=d25a894a&scoped=true&ts=true"
import script from "./ProfileThumbnail.vue?vue&type=script&lang=ts"
export * from "./ProfileThumbnail.vue?vue&type=script&lang=ts"

import "./ProfileThumbnail.vue?vue&type=style&index=0&id=d25a894a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25a894a"]])

export default __exports__